// Public Trust Center document — served at /trust/:slug for each file in
// docs/trust/. These are the URLs referenced by src/lib/complianceEvidence.ts.

import { Link, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getTrustDoc } from './trustDocs';
import { TrustLayout } from './TrustLayout';
import { trustMarkdownComponents } from './trustMarkdown';

export default function TrustDocument() {
  const { slug = '' } = useParams();
  const doc = getTrustDoc(slug);

  if (!doc) {
    return (
      <TrustLayout title="Document not found">
        <p>That Trust Center document does not exist.</p>
        <p>
          <Link to="/trust">← Back to the Trust Center</Link>
        </p>
      </TrustLayout>
    );
  }

  return (
    <TrustLayout title={doc.title}>
      <p className="not-prose mb-6">
        <Link to="/trust" className="text-sm text-[var(--text-ter)] hover:underline">
          ← Trust Center
        </Link>
      </p>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={trustMarkdownComponents}>
        {doc.content}
      </ReactMarkdown>
    </TrustLayout>
  );
}
